module.exports = __webpack_public_path__ + "static/media/CL.a173afe0.png";